// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3rav_","actions":"GroupTable_actions__8woju","deleteModalFooter":"GroupTable_deleteModalFooter__2wS98"};